import { raiseInfoMessage } from '@applyboard/ui-utils';
export default raiseInfoMessage;